import React, { useState } from "react";
import { Menu, X } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import "./navbar.css";

const NAV_LINKS = [
  { label: "الرئيسية", to: "/" },
  { label: "من نحن", to: "/AboutUs" },
  { label: "منتجاتنا", to: "/Products" },
  { label: "تواصل معنا", to: "/ContactUs" },
];

export default function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const closeMenu = () => setIsOpen(false);

  return (
    <nav className="navbar">
      <div className="navbar-container">
        {/* الروابط على اليمين */}
        <div className="navbar-links-wrapper">
          <div className="navbar-links desktop-only">
            {NAV_LINKS.map((link) => (
              <Link
                key={link.label}
                to={link.to}
                className={`nav-link ${
                  location.pathname === link.to ? "active" : ""
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* Mobile Menu Button */}
          <div className="mobile-only">
            <button onClick={() => setIsOpen(!isOpen)} className="menu-toggle">
              {isOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>
        </div>

        {/* اللوجو على اليسار */}
        <div className="navbar-logo-wrapper">
          <Link to="/" className="logo flex">
            <img className="navImage" src="\images\final.webp" alt="Biscoza" />
          </Link>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="mobile-menu">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.label}
              to={link.to}
              className={`mobile-nav-link ${
                location.pathname === link.to ? "active" : ""
              }`}
              onClick={closeMenu}
            >
              {link.label}
            </Link>
          ))}
        </div>
      )}
    </nav>
  );
}
